import { useRouteMatch } from 'react-router'

export const PUBLIC_CATALOG_PATH = '/:locale/catalog'

export const useIsPublicPage = (): boolean => {
  const match = useRouteMatch(PUBLIC_CATALOG_PATH)

  return !!match
}
